import { defineStore } from "pinia"
import { marked } from "marked"
import { fetchApiJson } from "@/services/repowerAPIService.js"
import DOMPurify from "dompurify"
import HTTP_STATUS from "@/helpers/httpStatus.js"

/**
 * Parses a wiki.js page into an object with metadata and sanitized HTML content
 */
function parse(text) {
  const [meta, markdown] = text.split(/\r?\n---\r?\n/)
  // Parse meta to object
  const metadata = [...meta.matchAll(/(.*): (.*)/g)].reduce(
    (obj, [_, key, value]) => ({ ...obj, [key]: value }),
    {},
  )
  // Parse markdown to HTML and sanitize to protect against XSS attacks
  const parsed = DOMPurify.sanitize(marked.parse(markdown))
  return { ...metadata, content: parsed }
}

export default defineStore("wikiStore", {
  state: () => ({
    pages: {},
  }),
  actions: {
    /**
     * Load a page with the given path from the wiki repository.
     */
    loadPage(path, onSuccess, onFail) {
      // Return cached page if available
      if (this.pages[path]) {
        onSuccess?.(this.pages[path])
        return
      }
      fetchApiJson(`/wiki/?path=${path}`)
        .then((response) => {
          if (response.status === HTTP_STATUS.OK) {
            return response.content
          } else {
            const error = new Error(response.error)
            error.code = response.status
            throw error
          }
        })
        .then((text) => {
          this.pages[path] = parse(text)
          onSuccess?.(this.pages[path])
        })
        .catch((error) => {
          onFail?.(error)
        })
    },
  },
})
